import {
  PRISM_ANIMATION_3DROTATE,
  PRISM_ANIMATION_HOVER,
  PRISM_BASE_WOBBLE_DISABLED,
  PRISM_BASE_WOBBLE_ENABLED,
} from './prismConstants';
import type { PrismAnimationType, PrismProgram } from './prismTypes';
import type { PrismPointerTracker } from './prismRotation';

interface ApplyPrismInteractionModeInput {
  animationType: PrismAnimationType;
  pointer: PrismPointerTracker;
  program: PrismProgram;
  startRAF: () => void;
}

export function applyPrismInteractionMode({
  animationType,
  pointer,
  program,
  startRAF,
}: ApplyPrismInteractionModeInput): () => void {
  if (animationType === PRISM_ANIMATION_HOVER) {
    const onPointerMove = (event: PointerEvent): void => {
      pointer.move(event);
      startRAF();
    };
    const onLeave = (): void => {
      pointer.leave();
    };

    window.addEventListener('pointermove', onPointerMove, { passive: true });
    window.addEventListener('mouseleave', onLeave);
    window.addEventListener('blur', onLeave);
    program.uniforms.uUseBaseWobble.value = PRISM_BASE_WOBBLE_DISABLED;

    return (): void => {
      window.removeEventListener('pointermove', onPointerMove as EventListener);
      window.removeEventListener('mouseleave', onLeave);
      window.removeEventListener('blur', onLeave);
    };
  }

  program.uniforms.uUseBaseWobble.value =
    animationType === PRISM_ANIMATION_3DROTATE ? PRISM_BASE_WOBBLE_DISABLED : PRISM_BASE_WOBBLE_ENABLED;

  return noop;
}

function noop(): void {
  return undefined;
}
